import { axiosClient } from '@nx-frontend/shared/api';
import { TrialServiceBusinessTrialDto } from '@nx-frontend/shared/types';

interface GetTrialsOptions {
  host: string;
  userId: number;
}

export async function getTrials(options: GetTrialsOptions): Promise<TrialServiceBusinessTrialDto[] | null> {
  const { host, userId } = options;
  let trials: TrialServiceBusinessTrialDto[] | null = null;

  try {
    const response = await axiosClient.get<TrialServiceBusinessTrialDto[]>(`${host}/v1/businessOrgTrials`, {
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
    });
    trials = response.data;
  } catch (err) {
    console.error(`getTrials error: ${err}`);
  }

  return trials;
}
